import type { ReactElement } from 'react';
import { FilterSelect, Input } from '@/shared/ui';

interface ReviewListFiltersProps {
  readonly productId: string;
  readonly rating: string;
  readonly status: string;
  readonly photo: string;
  readonly productIdInvalid: boolean;
  readonly onProductIdChange: (value: string) => void;
  readonly onRatingChange: (value: string) => void;
  readonly onStatusChange: (value: string) => void;
  readonly onPhotoChange: (value: string) => void;
}

/** 후기 목록 필터 — 상품 id(올바른 uuid 일 때만 적용)·별점·상태·사진 유무. */
export const ReviewListFilters = ({
  productId,
  rating,
  status,
  photo,
  productIdInvalid,
  onProductIdChange,
  onRatingChange,
  onStatusChange,
  onPhotoChange,
}: ReviewListFiltersProps): ReactElement => (
  <div className="flex flex-wrap items-center gap-2">
    <Input
      aria-label="상품 ID"
      aria-invalid={productIdInvalid}
      className="w-80"
      placeholder="상품 ID(전체 입력)"
      value={productId}
      onChange={(event) => onProductIdChange(event.target.value)}
    />
    <FilterSelect
      aria-label="별점 필터"
      value={rating}
      onChange={(e) => onRatingChange(e.target.value)}
    >
      <option value="">전체 별점</option>
      {[5, 4, 3, 2, 1].map((value) => (
        <option key={value} value={String(value)}>
          {value}점
        </option>
      ))}
    </FilterSelect>
    <FilterSelect
      aria-label="상태 필터"
      value={status}
      onChange={(e) => onStatusChange(e.target.value)}
    >
      <option value="">전체 상태</option>
      <option value="VISIBLE">공개 후기</option>
      <option value="HIDDEN">숨김 후기</option>
    </FilterSelect>
    <FilterSelect
      aria-label="사진 필터"
      value={photo}
      onChange={(e) => onPhotoChange(e.target.value)}
    >
      <option value="">사진 전체</option>
      <option value="true">사진 있음</option>
      <option value="false">사진 없음</option>
    </FilterSelect>
    {productIdInvalid ? (
      <p className="text-xs text-destructive">올바른 상품 ID가 아니라서 적용하지 않았습니다.</p>
    ) : null}
  </div>
);
